import React from "react";

import "./Loading.css";

const Loading: React.FC = props => {
    return (
        <p className="Loading">Loading charts...</p>
    );
};

export default Loading;
